module.exports = __webpack_public_path__ + "img/SACOMBANK.029f69e8.svg";